import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

import { TreeNode } from 'primeng';
import { indexOf, difference } from 'lodash';
import { CustomerService } from '../../services';
import { OrganisationTagsService } from '../../services';

@Component({
  selector: 'tagging-select-customer',
  templateUrl: 'tagging-select-customer.component.html',
  styleUrls: ['tagging-select-customer.component.css'],
})
export class TaggingSelectCustomerComponent implements OnInit {
  constructor(
    private customerService: CustomerService,
    private organisationTagsService: OrganisationTagsService,
  ) {}

  cols: any[];
  customers: any[];
  _selectedCustomers: any[] = [];

  @Output() selectedCustomersChanged: EventEmitter<any[]> = new EventEmitter<any[]>();

  get selectedCustomers(): any[] {
    return this._selectedCustomers;
  }
  set selectedCustomers(value: any[]) {
    this._selectedCustomers = value;

    // emit event so parent component can do something with selected suppliers
    this.selectedCustomersChanged.emit(this._selectedCustomers);
  }

  @Input('parentSelectedCustomers')
  public set parentSelectedCustomers(value: any[]) {
    this._selectedCustomers = value;
  }
  public get parentSelectedCustomers() {
    return this._selectedCustomers;
  }

  isLoading: boolean;

  public customerFilter: {
    name: string;
    town: string;
    postcode: string;
  } = { name: '', town: '', postcode: '' };
  first: number = 0;

  ngOnInit() {
    this.setColumns();
    this.loadOrganisationStructure();
  }

  setColumns() {
    this.cols = [
      { field: 'name', header: 'Customer/Department/Team' },
      { field: 'orderPreferences', header: 'Excluded Supplier(s)' },
      { field: 'tags', header: 'Tags' },
    ];
  }

  loadOrganisationStructure() {
    this.isLoading = true;

    // returns the customer organisation structure along with the tags and exclusions for each dept/team
    // in a format that can be used in the tree table component (i.e. Data and Children in each item)
    this.organisationTagsService.getAllCustomerOrganisationData().subscribe((result) => {
      //console.log("Customer organisation structure loaded: ", result);
      this.customers = result;

      if (this.selectedCustomers) this.selectedCustomers.length = 0;

      //this.expandNodes(this.orgNodes[0]);
      this.isLoading = false;
    });
  }

  parentChecked(rowNode: any): boolean {
    let parentChecked =
      (rowNode.node.parent != null && indexOf(this.selectedCustomers, rowNode.node.parent) >= 0) ||
      (rowNode.node.parent != null &&
        rowNode.node.parent.parent != null &&
        indexOf(this.selectedCustomers, rowNode.node.parent.parent) >= 0);

    return parentChecked;
  }

  isRowSelected(rowNode: any): boolean {
    return this.selectedCustomers && indexOf(this.selectedCustomers, rowNode.node) >= 0;
  }

  toggleRowSelection(rowNode: any) {
    if (this.parentChecked(rowNode)) return;

    if (this.isRowSelected(rowNode)) {
      this.selectedCustomers.splice(this.selectedCustomers.indexOf(rowNode.node), 1);
    } else {
      this.selectedCustomers.push(rowNode.node);

      // if the node has children, remove them from the selection array
      this.removeChildrenFromSelectedItems(rowNode.node);
    }

    this.selectedCustomers = [...this.selectedCustomers];
  }

  removeChildrenFromSelectedItems(node: TreeNode) {
    if (node.children && node.children.length > 0) {
      this.selectedCustomers = difference(this.selectedCustomers, node.children);

      node.children.forEach((x) => {
        this.removeChildrenFromSelectedItems(x);
      });
    }
  }

  customerHasPreferences(rowNode) {
    return rowNode.node.data.orderPreferences && rowNode.node.data.orderPreferences.length > 0;
  }

  searchCustomer() {}

  clearCustomerFilter() {}

  getNodeName(node: TreeNode): string {
    // work backwards up the tree prepending the parent name
    let resultObj = { str: '' };
    this.getNodeNameRecursive(node, resultObj);

    return resultObj.str;
  }

  getNodeNameRecursive(node: TreeNode, resultObj: { str: string }) {
    if (node.parent) this.getNodeNameRecursive(node.parent, resultObj);

    resultObj.str = resultObj.str + (resultObj.str.length > 0 ? ' - ' : '') + node.data.name;
  }
}
